module.exports = __webpack_public_path__ + "img/activation_code.11ce8277.png";